document.addEventListener('DOMContentLoaded', function () {
    flatpickr('.flatpickr', {
            'locale': 'sv',
            wrap: true,
            mode: 'single',
            altInput: false,
            altFormat: 'Y-m-d',
            dateFormat: 'Y-m-d',
            disableMobile: 'true',
            minDate: "today"
        },
    );
});
//# sourceMappingURL=flatpickr-settings.js.map
